import React from 'react';
import { Helmet } from 'react-helmet';
import './ContactUs.css';
import { 
  FaEnvelope, 
  FaInstagram, 
  FaLinkedin, 
  FaDiscord, 
  FaGithub, 
  FaPaperPlane 
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // Correct X/Twitter Icon

const ContactUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
  };

  return (
    <div className="contact-container">
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Contact Us - InternCourse: Get in Touch with Our Team</title>
        <meta 
          name="description" 
          content="Contact InternCourse for any inquiries, support, or feedback. Reach out via email, Instagram, or join our community." 
        />
        <meta 
          name="keywords" 
          content="Contact InternCourse, support, feedback, help with courses, learning, contact for online learning, customer support" 
        />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Contact InternCourse: Get in Touch with Our Team" />
        <meta property="og:description" content="Get in touch with InternCourse's team for any questions, support, or feedback about our online courses and services." />
        <meta property="og:image" content="https://interncourse.online/images/contact-image.jpg" />
        <meta property="og:url" content="https://interncourse.online/contact" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us - InternCourse: Reach Out to Our Team" />
        <meta name="twitter:description" content="Have any questions or need support? Contact InternCourse's team for assistance." />
        <meta name="twitter:image" content="https://interncourse.online/images/contact-image.jpg" />
        <meta name="twitter:site" content="@InternCourse" />

        <link rel="canonical" href="https://interncourse.online/contact" />
      </Helmet>

      {/* Header Section */}
      <div className="contact-header">
        <h1>Get in Touch</h1>
        <p>
          We’d love to hear from you! Whether you have questions, feedback, or need assistance with courses,
          reach out to us directly or through our active channels.
        </p>
      </div>

      {/* Contact Cards Grid */}
      <div className="contact-grid">
       
        {/* Email Card */}
        <a href="mailto:info@interncourse.online" className="contact-card email-card">
          <div className="card-icon">
            <FaEnvelope size={28} />
          </div>
          <div className="card-info">
            <h3>Email Us</h3>
            <p>info@interncourse.online</p>
            <span className="card-link-text">Send an Email &rarr;</span>
          </div>
        </a>

        {/* Instagram DM Card */}
        <a 
          href="https://www.instagram.com/intern_course/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="contact-card instagram-card"
        >
          <div className="card-icon">
            <FaInstagram size={28} />
          </div>
          <div className="card-info">
            <h3>Direct Message</h3>
            <p>@intern_course on Instagram</p>
            <span className="card-link-text">Open Instagram &rarr;</span>
          </div>
        </a>

        {/* Community / Discord Card */}
        <a 
          href="https://discord.gg/your-discord-invite" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="contact-card community-card"
        >
          <div className="card-icon">
            <FaDiscord size={28} />
          </div>
          <div className="card-info">
            <h3>Student Community</h3>
            <p>Join our Discord server</p>
            <span className="card-link-text">Join Community &rarr;</span>
          </div>
        </a>
      </div>

      {/* Direct Message Form Section */}
      <div className="contact-form-wrapper">
        <h2>Send Us a Message</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input id="name" type="text" placeholder="Your Full Name" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" placeholder="Your Email Address" required />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea id="message" rows="5" placeholder="How can we help you?" required></textarea>
          </div>

          <button type="submit" className="submit-btn">
            <FaPaperPlane className="btn-icon" /> Send Message
          </button>
        </form>
      </div>

      {/* Social Media Footer Links */}
      <div className="social-media-section">
        <p>Follow us across our official channels:</p>
        <div className="social-icons">
          <a 
            href="https://x.com/07InternCourse" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="X (Twitter)"
            className="social-icon x-icon"
          >
            <FaXTwitter size={20} />
          </a>
          <a 
            href="https://www.instagram.com/intern_course/" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Instagram"
            className="social-icon insta-icon"
          >
            <FaInstagram size={20} />
          </a>
          <a 
            href="https://www.linkedin.com/in/interncourse/" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="LinkedIn"
            className="social-icon linkedin-icon"
          >
            <FaLinkedin size={20} />
          </a>
          <a 
            href="https://github.com/your-github" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="GitHub"
            className="social-icon github-icon"
          >
            <FaGithub size={20} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;